import { Directive, ElementRef, HostListener, Self } from '@angular/core';
import { NgControl } from '@angular/forms';

/** Matches the legacy numeric-only parser without changing leading zeros. */
@Directive({ selector: 'input[sfNumericOnly]', standalone: true })
export class NumericOnlyDirective {
  constructor(private element: ElementRef<HTMLInputElement>, @Self() private control: NgControl) {}

  @HostListener('input')
  normalize(): void {
    const input = this.element.nativeElement;
    const normalized = input.value.replace(/[^0-9]/g, '');
    if (normalized !== input.value) {
      input.value = normalized;
      this.control.control?.setValue(normalized);
    }
  }
}
